module.exports = __webpack_public_path__ + "img/logo_top.f1f34168.png";